import { render, staticRenderFns } from "./TransferAllModal.vue?vue&type=template&id=63627084"
import script from "./TransferAllModal.vue?vue&type=script&lang=js"
export * from "./TransferAllModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports